import { Button, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { debounce } from "lodash";
import React, { Suspense, memo, useCallback, useEffect, useMemo,useRef } from "react";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { useDispatch, useSelector } from "react-redux";
import { useNavigate,useLocation} from "react-router-dom";
import { getAllCalendarTickets, getAllTickets,getAgentWithGroup } from "../../../redux/actions/TicketsManagement/TicketsManagement";
import { IState } from "../../../redux/reducers/rootReducers";
import AgentsOption from "./FilterComponents/AgentsOption";
import CalendarRangeOption from "./FilterComponents/CalendarRangeOption";
import FilterOptions from "./FilterComponents/FilterOptions";
import LayoutShift from "./FilterComponents/LayoutShift";
import MoreActions from "./FilterComponents/MoreActions";
import ResetFilters from "./FilterComponents/ResetFilter";
import SearchBox from "./FilterComponents/SearchBox";
import SortOption from "./FilterComponents/SortOption";
import { IDashboardSecondaryNavbar } from "./SecondaryNavbar";
import { handleTime } from "../../helpers/helperFunctions";
const CommonAppFilter:React.FC<IDashboardSecondaryNavbar> = memo((
  props: IDashboardSecondaryNavbar
) => {
    const {hideExtraIcons= false,hideAddBtn,hideViewMode,hideAgent,hideSearch,hideSort,hideFilter,report,page=""} = props;
//     console.log('TicketDashboardHolder-CommonAppFilter')
    const LayoutType: any = useSelector((state: IState) => state?.LayoutTicketManagementReducer?.layout ?? "Status");
    const AllData = useSelector((state: IState) => state?.TicketsReducer?.allResponses);
    const currAgent = useSelector((state: IState) => state?.agentReducer?.loggedInAgent);
    const FiltersVal: any = useSelector((state: IState) => state?.filtersTicketManagementReducer);
    const AllInfo = useSelector((state: IState) => state?.TicketsReducer?.alldataStructure);
     const AllTickets = useSelector((state: IState) => state?.AllTicketsReducer?.otherTickets);
    const dispatch = useDispatch();
    const classes = useStyles();
    const navigate = useNavigate();
   const location = useLocation();
   const locationState = location.state as { forceReload?: boolean } | null;
    const prevFilters = useRef(FiltersVal);
    const prevLayout = useRef(LayoutType);
    const addNewTicket = useCallback(() => {
      navigate('/home/ticket/new-ticket')
    },[]);
    //const [loader,setLoader] = useState(false);
    const callback=()=>{
      //setLoader(false)
    }

    const grpCB = () => {
    }

    let s = report
   
  useEffect(()=>{
        if (prevLayout.current !== LayoutType) {
        prevLayout.current = LayoutType;
        prevFilters.current = FiltersVal;
        loadTickets();
        return;
      }
    if (AllTickets.length == 0 || locationState?.forceReload) {
        prevFilters.current = FiltersVal;
        loadTickets();
         window.history.replaceState({}, document.title);
        return;
    }
      // console.log("previous__",prevFilters.current)
      // console.log("current__",FiltersVal,LayoutType)

    if (JSON.stringify(prevFilters.current) !== JSON.stringify(FiltersVal)) {
      prevFilters.current = FiltersVal;
      loadTickets(); 
    }
    },[FiltersVal,LayoutType])

  const loadTickets = ()=>{
    if(!AllData?.ticketStatus ) return;//|| firstload
    handleTime.cancel();
    handleTime.setup(()=>{
      document.body.classList.add('loader');
      if(page==='calendar'){
        dispatch(getAllCalendarTickets(FiltersVal,AllData,callback))
      }else{
        dispatch(getAllTickets(FiltersVal,AllData,AllInfo,callback,s,LayoutType))
        dispatch(getAgentWithGroup(FiltersVal,AllData,currAgent?.roleId,grpCB))
      }      
    },1500);
  }
  const addBtn = useMemo(()=><>
  {!hideAddBtn &&
  <Button className={classes.addNewButton}onClick={addNewTicket}variant="contained">New Item</Button>}
  </>,[hideAddBtn,classes]);

  const resetAndCalendar = useMemo(()=><><CalendarRangeOption />
  <ResetFilters /></>,[classes])
  const LayoutShiftOption = useMemo(()=><>{!hideViewMode && <LayoutShift /> }</>,[hideViewMode,classes]);
  const SearchBoxOption = useMemo(()=><>{!hideSearch && <SearchBox /> }</>,[hideSearch,classes]);
  const FilterOptionsOption = useMemo(()=><>{!hideFilter && <FilterOptions showOrgFilter={props.showOrgFilter} /> }</>,[hideFilter,classes]);
  const SortOptionOption = useMemo(()=><>{!hideSort && <SortOption /> }</>,[hideSort,classes]);
  const AgentsOptionOption = useMemo(()=><>{!hideAgent && <AgentsOption /> }</>,[hideAgent,classes]);
  // const MoreActionsOption = ()=><MoreActions report={report} hideExtraIcons={hideExtraIcons}/>;
  const filterHolder = useMemo(() => <>
    <div className={`sticky-Top-0 ${classes.row} ${classes.gap10} ${classes.alignCenter} tickect-management-button`} style={{ justifyContent: "space-evenly",}}>
      <Suspense fallback={<Typography className="ticket-ms-loading">Loading...</Typography>}>
        {/* {!hideAddBtn &&
          <Button className={classes.addNewButton}
            onClick={addNewTicket}
            variant="contained" 
          >New Item</Button>
        } */}
        {addBtn}
        {SearchBoxOption}
        {FilterOptionsOption}
        {SortOptionOption}
        {LayoutShiftOption}
        {AgentsOptionOption}
        {/* {!hideSearch && <SearchBox />} */}
        {/* {!hideFilter &&<FilterOptions />} */}
        {/* {!hideSort && <SortOption />} */}
        {/* {!hideAgent && <AgentsOption />} */}
        {resetAndCalendar}
        {/* {MoreActionsOption} */}
        <MoreActions report={report} hideExtraIcons={hideExtraIcons} page={page}/>
        {/* <MoreActions report={report} hideExtraIcons={hideExtraIcons} /> */}
      </Suspense>
    </div></>, [classes])
  return (<>
      {filterHolder}
    </>
  );
})


const useStyles = makeStyles(() => ({
  filterBox:{
      padding: "1.5rem 0",
      borderBottom: "1px solid #ddd"
  },
  row:{
    display:"flex"
  },
  alignCenter:{
    alignItems:"center"
  },
  gap10:{
    gap:"10px"
  },
  addNewButton: {
    color: "white",
    height: "23px",
    fontSize: "9px",
    backgroundColor: "#007bff",
    padding: "2px",
    whiteSpace: "nowrap",
  }
}));
export default CommonAppFilter;